import Link from 'next/link';
import React from 'react';
import styled, { css } from 'styled-components';

type Color = 'green' | 'transparent' | 'white' | 'red';

interface IButtonProps {
  children: React.ReactNode;
  onClick?: Function;
  color?: Color;
  href?: string | Object;
  hrefOutside?: string;
  disabled?: boolean;
  fontSize?: string;
}

export default function Button({
  children,
  onClick,
  color = 'green',
  href,
  hrefOutside,
  disabled = false,
  fontSize
}: IButtonProps) {

  const clickHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if(disabled) return;
    onClick && onClick(e);
  }

  let Container_ = <Container onClick={clickHandler} color={color} disabled={disabled} href={hrefOutside} target={hrefOutside?'_blank':''} fontSize={fontSize}>{children}</Container>
  if(href) Container_ = <Link href={href} legacyBehavior>{Container_}</Link>

  return Container_

}

const Container = styled.a<{color: Color, disabled: boolean, fontSize: string}>`
  display: inline-flex;
  color: #fff;
  border: 1px solid var(--green);
  background-color: var(--green);
  border-radius: 4px;
  height: 39px;
  padding: 0 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${p => p.fontSize || '14px'};

  ${p => p.color === 'transparent' && css`
    color: var(--green);
    border: 1px solid var(--green);
    background: none;

    &:hover {
      color: var(--green) !important;
      opacity: 0.7;
    }
  `}
  ${p => p.color === 'white' && css`
    color: var(--white);
    border: 1px solid var(--white);
    background: none;

    &:hover {
      color: var(--white) !important;
      opacity: 0.7;
    }
  `}
  ${p => p.color === 'red' && css`
    min-width: 200px;
    padding: 0 40px;
    color: var(--white);
    border: 1px solid var(--red);
    background: var(--red);

    &:hover {
      color: var(--red) !important;
      background: none;
    }
  `}
  ${p => p.disabled && css`
    pointer-events: none;
    opacity: 0.5;
  `}
  &:hover {
    background-color: initial;
  }

  & button {
    color: inherit !important;
  }
`